// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"at","header":"au","copy":"av","formWrapper":"aw","formLabel":"ax","dismissModal":"ay","buttonRow":"az","buttonWrapper":"aA","button":"aB"};